import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Pane, Select } from 'evergreen-ui'
import gql from "graphql-tag";

const LOGOUT = gql`
    query Logout {
        logout
    }
`

export default () => {
    const { data, error, loading } = useQuery(LOGOUT);
    if (error) return <Pane>Error</Pane>;
    if (loading) return <Pane>Ładowanie...</Pane>;
    window.location.assign('/')
}